<template>
  <BasePopup
    :show="show"
    :show-close-button="false"
    :close-on-overlay="false"
    @close="$emit('close')"
  >
    <div class="confirm-popup-content">
      <!-- 標題 -->
      <div class="popup-title">{{ title }}</div>

      <!-- 描述文字 (可選) -->
      <div v-if="description" class="popup-description">{{ description }}</div>

      <div class="confirm-buttons">
        <button
          class="confirm-btn confirm-btn--cancel"
          @click="$emit('cancel')"
        >
          {{ cancelText }}
        </button>
        <button
          class="confirm-btn confirm-btn--confirm"
          @click="$emit('confirm')"
        >
          {{ confirmText }}
        </button>
      </div>
    </div>
  </BasePopup>
</template>

<script>
import BasePopup from '@/components/Page/Web/PartnerMarketing/BasePopup.vue'

export default {
  name: 'ConfirmPopup',
  components: { BasePopup },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: '確定'
    },
    cancelText: {
      type: String,
      default: '取消'
    }
  }
}
</script>

<style lang="scss" scoped>
.confirm-buttons {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 20px;
}

.confirm-btn {
  width: 128px;
  height: 40px;
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &--cancel {
    background: transparent;
    border-color: #FE577F;
    color: #FE577F;
  }

  &--confirm {
    background: #FE577F;
    border-color: #FE577F;
    color: white;
  }
}
</style>